<script setup lang="ts">
  import { useUserStore } from '@bv/stores/user';
  import { storeToRefs } from 'pinia';

  import { usePresence } from '@/stores/general/presence.store';

  const { extensionDetails } = storeToRefs(useUserStore());

  const { currentUserPresence } = storeToRefs(usePresence());
</script>

<template>
  <img
    v-if="extensionDetails?.number && currentUserPresence?.icon"
    :alt="currentUserPresence.name"
    class="h-3.5 w-3.5 rounded-full"
    :src="currentUserPresence.icon"
  />
</template>
